<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="批次号">
                <el-input v-model="formInline.batchNo" placeholder="批次号" style="width:220px"></el-input>
            </el-form-item>
            <el-form-item label="批次名称">
                <el-input v-model="formInline.batchName" placeholder="批次名称" style="width:180px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="findGiftCardBatch">查询</el-button>
                <el-button type="success" @click="addGiftCardBatch">新增</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="giftCardBatchList" stripe border center :size="GCONFIG.styleTableSize" v-show="!showDialog"  v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="batchNo" label="批次号" ></el-table-column>
            <el-table-column prop="batchName" label="批次名称"></el-table-column>
            <el-table-column prop="batchNum" label="批次数量"></el-table-column>
            <el-table-column prop="batchMoney" label="金额"></el-table-column>
            <el-table-column prop="outBoundNum" label="出库数"></el-table-column>
            <el-table-column label="操作" fixed="right" width="250">
                <template slot-scope="scope">
                    <!-- <el-button type="warning" size="mini" @click="handleUpdate(scope.row)">修改</el-button> -->
                    <el-button-group>
                        <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
                        <el-button type="info" size="mini"  @click="handledCancel(scope.row)" style="margin-bottom: 5px">禁用</el-button>
                        <el-button type="success" size="mini" @click="handleGiftCardGetListPage(scope.row)">查看</el-button>
                    </el-button-group>
<!--                    <el-button-group>-->
<!--                        <el-button type="warning" size="mini" @click="handleBalanceCardDetailList(scope.row)">礼品卡明细</el-button>-->
<!--                        <el-button type="primary" size="mini" @click="handleBalanceCardOutList(scope.row)">出库记录</el-button>-->
<!--                    </el-button-group>-->
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <!-- 新增批次window -->
        <el-dialog title="新增批次" :visible.sync="dialogFormVisible" center  center top="5vh">
            <el-form :model="form" label-width="120px" size="small ">
                <el-form-item label="批次号">
                    <el-input v-model="form.batchNo" placeholder="无需输入" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="批次名称" :required="true">
                    <el-input v-model="form.batchName" placeholder="批次名称" clearable ></el-input>
                </el-form-item>
                <el-form-item label="批次数量" >
                    <el-input-number v-model="form.batchNum" :min="0" :max="10000" label="批次数量"></el-input-number>
                </el-form-item>
                <el-form-item label="金额" >
                    <el-input-number v-model="form.batchMoney" :min="0" :max="10000" label="金额"></el-input-number>
                </el-form-item>
                <!--<el-form-item label="期限">
                    <el-input-number v-model="form.cardValidity" :min="1" :max="1000" label="期限"></el-input-number>
                </el-form-item>-->
                <el-form-item label="开始日期">
                    <el-date-picker
                            v-model="form.cardStartTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                    <el-date-picker
                            v-model="form.cardEndTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="用途">
                    <el-input type="textarea" :rows="2" placeholder="用途" v-model="form.batchUse"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" :rows="2" placeholder="备注" v-model="form.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAddGiftCardBatch(form)">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 查看批次券码window -->
        <el-dialog  title="批次券码列表" :visible.sync="dialogFormVisible1" center :fullscreen="true">
            <el-form :inline="true" :model="formInline1" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                <el-form-item label="卡号">
                    <el-input v-model="formInline1.cardNo" placeholder="卡号"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getGiftCardInfo">查询</el-button>
                    <el-button type="warning" @click="dialogFormVisible1 = false">关闭</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="dataList1" stripe border center :size="GCONFIG.styleTableSize">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="cardNo" label="卡号"></el-table-column>
                <el-table-column prop="cardCash" label="金额"></el-table-column>
                <el-table-column prop="cardStartTime" label="开始时间"></el-table-column>
                <el-table-column prop="cardEndTime" label="结束时间"></el-table-column>
                <el-table-column :formatter="cardStateName" label="状态"></el-table-column>
                <el-table-column prop="activateTime" label="激活时间"></el-table-column>
                <el-table-column label="用户Id" width="170">
                    <template slot-scope="scope">
                        <a :href="`http://cmscheck.lechun.cc/#/usersystem/detail/${scope.row.customerId}`" target="_blank"  class="customer-id">{{ scope.row.customerId }}</a>
                        <span style="margin-left: 10px"></span>
                    </template>
                </el-table-column>


                <el-table-column label="操作" fixed="right" width="80">
                    <template slot-scope="scope">
                        <el-button type="info" size="mini" v-if="scope.row.cardState==0"  @click="handledCancelCard(scope.row)">禁用</el-button>
                        <el-button type="success" size="mini" v-if="scope.row.cardState==-1"  @click="handledStartCard(scope.row)">启用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="formInline1.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline1.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline1.recordsTotal">
                </el-pagination>
            </div>
        </el-dialog>
        <!-- 出库记录 -->
        <el-drawer
            size="70%"
            title="礼品卡出库记录"
            :visible.sync="outListVisible">
            <CardBalanceOut ref="outDrawer" :batchNo="currentBatchNo"/>
        </el-drawer>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {findGiftCardBatches,generateGiftCardBatch,findGiftCards,delGiftCardBatch,cancelGiftCardBatch,invalidCard} from '@/api/api';
    import CardBalanceOut from '@/components/card/CardOutList.vue'
    export default {
        data() {
            return {
                showDialog: false,
                dialogFormVisible: false,
                dialogFormVisible1: false,
                outListVisible: false,
                giftCardBatchList: [],// 批次信息
                dataList1:[],
                loading: true,
                form: {
                    batchNo: '',
                    batchName: '',
                    batchNum: 100,
                    batchMoney: 0,
                    cardValidity: 7,
                    cardStartTime: '',
                    cardEndTime: '',
                    batchUse:'',
                    remark:''
                },
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                formInline1:{
                    batchNo: '',
                    cardNo:'',
                    cardState:'',
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                currentBatchNo:''
            }
        },
        components: {
            CardBalanceOut
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.queryGiftCardBatch();
        },
        methods: {
            queryGiftCardBatch(){
                this.loading = true;
                findGiftCardBatches(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.giftCardBatchList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            //查询
            findGiftCardBatch(){
                this.queryGiftCardBatch();
                this.formInline.currentPage = 1
            },

            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.queryGiftCardBatch();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.queryGiftCardBatch();
            },

            //新增事件
            addGiftCardBatch() {
                this.form = {
                    batchNo: '',
                    batchName: '',
                    batchNum: 1000,
                    batchMoney: 0,
                    cardValidity: 7,
                    cardStartTime: '',
                    cardEndTime: '',
                    batchUse:'',
                    remark:''
                }
                this.dialogFormVisible = true;
            },

            //修改事件
            handleUpdate(row) {
                this.form = {
                    batchNo: row.batchNo,
                    batchName: row.batchName,
                    batchNum: row.batchNum,
                    batchMoney: row.batchMoney,
                    cardValidity: row.cardValidity,
                    cardStartTime: row.cardStartTime,
                    cardEndTime: row.cardEndTime,
                    batchUse: row.batchUse,
                    remark: row.remark
                }
                this.dialogFormVisible = true;
            },

            //删除事件
            handleDelete(row){
                this.$confirm('删除批次, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delGiftCardBatch({batchId:row.batchNo}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryGiftCardBatch();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },

            //禁用事件
            handledCancel(row){
                this.$confirm('禁用批次, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    cancelGiftCardBatch({batchId:row.batchNo}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryGiftCardBatch();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },

            //禁用批次券码事件
            handledCancelCard(row){
                this.$confirm('禁用此卡, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    invalidCard({cardNo:row.cardNo,cardState:-1}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryGiftCardInfo();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },

            //启用批次券码事件
            handledStartCard(row){
                this.$confirm('启用此卡, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    invalidCard({cardNo:row.cardNo,cardState:0}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryGiftCardInfo();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },

            //查看事件
            handleGiftCardGetListPage(row) {
                this.dialogFormVisible1 = true;
                this.formInline1.batchNo = row.batchNo;
                this.formInline1.cardNo = '';
                this.formInline1.cardState = '';
                this.queryGiftCardInfo();
            },

            queryGiftCardInfo() {
                findGiftCards(this.formInline1).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline1.recordsTotal = res.data.value.total;
                        this.dataList1 = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },

            //查询
            getGiftCardInfo(){
                this.queryGiftCardInfo();
                this.formInline1.currentPage = 1
            },
            //状态格式化
            cardStateName(row, column, cellValue) {
                if (row.cardState == 1) {
                    return "激活";
                } else if (row.cardState == 0) {
                    return "未激活";
                }else {
                    return "无效";
                }
            },
            handleSizeChange1(val) {
                this.formInline1.pageSize = val;
                this.queryGiftCardInfo()
            },
            handleCurrentChange1(val) {
                this.formInline1.currentPage = val;
                this.queryGiftCardInfo()
            },

            //确定事件
            updateOrAddGiftCardBatch(form) {
                var type="^[0-9]*[1-9][0-9]*$";
                var re = new RegExp(type);
                var flag=re.test(form.batchMoney);
                if(form.batchNum == 0 && !flag){
                    this.$message({
                        showClose: true,
                        message: '应为正整数!',
                        type: 'error'
                    });
                    return false;
                }
                if(form.batchName == "" || form.batchName == ''){
                    this.$message({
                        showClose: true,
                        message: '请填写名称',
                        type: 'error'
                    });
                    return false;
                }
                if(form.cardStartTime == "" || form.cardStartTime == '' ){
                    this.$message({
                        showClose: true,
                        message: '开始时间不能为空',
                        type: 'error'
                    });
                    return false;
                }
                if(form.cardEndTime == "" || form.cardEndTime == '' ){
                    this.$message({
                        showClose: true,
                        message: '结束时间不能为空',
                        type: 'error'
                    });
                    return false;
                }

                if(form.cardStartTime > form.cardEndTime){
                    this.$message({
                        showClose: true,
                        message: '结束时间不能早于开始时间',
                        type: 'error'
                    });
                    return false;
                }
                const loading = this.$loading(this.GCONFIG.loadingParam);
                generateGiftCardBatch(form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.queryGiftCardBatch();
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            //礼品卡明细
            handleBalanceCardDetailList(row){
                console.log(row)
                this.$router.push({path: '/balancecardbatch', query: {batchNo: row.batchNo}})
            },
            //出库记录
            handleBalanceCardOutList(row){
                console.log(row)
                this.outListVisible = true
                this.currentBatchNo = row.batchNo
                this.$nextTick(()=>{
                    console.log(this.$refs.outDrawer)
                    this.$refs.outDrawer.queryGiftCardBatch()
                })

            }
        }
    }
</script>
<style scoped>
    .customer-id{
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/giftCard/GiftCardBatch.vue